<template>
    <button v-if="type || !href"
            class="inline-flex items-center px-4 py-2 bg-primary text-white font-semibold text-xs uppercase tracking-widest"
            :type="type"
            :disabled="disabled">
        <slot></slot>
    </button>
    <Link v-else-if="!target"
          :href="href"
          class="inline-flex items-center px-4 py-2 bg-primary text-white font-semibold text-xs uppercase tracking-widest"
          :target="target">
        <slot/>
    </Link>

    <!-- we have to use a regular a tag for target="_blank"-->
    <a v-else
       :href="href"
       class="inline-flex items-center px-4 py-2 bg-primary text-white font-semibold text-xs uppercase tracking-widest"
       :target="target"
    >
        <slot></slot>
    </a>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    },

    props: ["type", "href", "disabled", "active", "target"],

    methods: {},
    computed: {}
}
</script>
